const columns = [
    {
        title: "Key Name",
        dataIndex: "keyName",
        sorter: false
    },
    {
        title: "Value",
        dataIndex: "value",
        sorter: false
    },
    {
        title: "isEnable",
        dataIndex: "isDefault",
    },

    {
        title: "Update date",
        dataIndex: "lastModifiedDate",
        sorter: false
    },
    {
        title: "Actions",
        dataIndex: "actions",
    },
];

export default columns;
